import Form from 'react-bootstrap/Form';

function ValidationFeedback({ validationResult, ...rest }) {
  const component = validationResult ? <Form.Control.Feedback { ...rest }>{ validationResult.message }</Form.Control.Feedback> : null;
  return component;
}

export default ValidationFeedback;